import { createPropStyling } from '../privatePropStylingUtils';
export const positionCssAttrNames = ['bottom', 'left', 'position', 'right', 'top', 'zIndex'];
export const positionPropStyling = createPropStyling(positionCssAttrNames);
//# sourceMappingURL=positionPropStyling.js.map